import React, { memo } from "react";
import { ThemeProvider, CssBaseline, useMediaQuery } from "@mui/material";

import useAuth from "./2_ksbHub/hooks/useAuth";
import useUserRoles from "./2_ksbHub/hooks/useUserRoles";
import useAppTheme from "./2_ksbHub/hooks/useAppTheme";
import useAppLoading from "./2_ksbHub/hooks/useAppLoading";
import useViewOptions from "./2_ksbHub/hooks/useViewOptions";
import KsbItAppBar from "./2_ksbHub/0_TemplatePage/components/1_KsbItAppBar/KsbItAppBar";
import { AppContext } from "./2_ksbHub/context/appContext";
import useScrollOverride from "./2_ksbHub/hooks/useScrollOverride";
import AppRoutes from "./2_ksbHub/router/AppRoutes";

function App() {
  const { theme, appInDarkMode, setAppInDarkMode } = useAppTheme();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down("sm"));
  const isMobile = useMediaQuery(theme.breakpoints.down("ss"));

  const auth = useAuth();
  const roles = useUserRoles(auth.currentUser);
  const appLoading = useAppLoading();
  const viewOptions = useViewOptions(auth.currentUser);

  useScrollOverride();

  return (
    <AppContext.Provider
      value={{
        ...auth, //passes everything exported by useAuth hook to context
        ...roles, //passes everything exported by useUserRoles hook to context
        ...appLoading, //passes erverything exported by useAppLoading hook to context
        ...viewOptions, //passes erverything exported by useViewOptions hook to context
        isSmallScreen,
        isMobile,
        appInDarkMode,
        setAppInDarkMode,
      }}
    >
      <ThemeProvider theme={theme}>
        <CssBaseline enableColorScheme />

        <KsbItAppBar />

        <AppRoutes />
      </ThemeProvider>
    </AppContext.Provider>
  );
}

export default memo(App);
